import { DeviceApi, DeviceInfo } from '@clients/myTrips' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars

let basePath = getBasePath() + '/my-trips'

export default class ExtendedDeviceApi extends DeviceApi {
  getDevice (deviceId: string, options?: any): AxiosPromise<DeviceInfo> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getDevice(deviceId, undefined, optionsParam)
  }
}
